import { render, staticRenderFns } from "./CloseRetrospectDetail.vue?vue&type=template&id=50315ee6&scoped=true"
import script from "./CloseRetrospectDetail.vue?vue&type=script&lang=js"
export * from "./CloseRetrospectDetail.vue?vue&type=script&lang=js"
import style0 from "./CloseRetrospectDetail.vue?vue&type=style&index=0&id=50315ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50315ee6",
  null
  
)

export default component.exports